export { default } from './Popup.vue'
export type { PopupProps } from './Popup.vue'

// 全局弹窗管理
class PopupManager {
  private static instances = new Set<number>()
  private static baseZIndex = 1000

  static register(): number {
    const zIndex = this.baseZIndex + this.instances.size
    this.instances.add(zIndex)
    return zIndex
  }

  static unregister(zIndex: number) {
    this.instances.delete(zIndex)
  }

  static getTopZIndex(): number {
    return Math.max(...Array.from(this.instances), this.baseZIndex)
  }
}

export { PopupManager }
